import { useStoreAuth } from "../store";

export default function useSSO() {
  const { client } = useStoreAuth();

  const listProviders = async () => {
    const { data, error } = await client.sso.providers();
    if (error) throw error;
    return data?.providers || [];
  };

  const registerProvider = async ({
    providerId,
    issuer,
    domain,
    oidcConfig,
    organizationId,
  }) => {
    const body = { providerId, issuer, domain };
    if (oidcConfig) body.oidcConfig = oidcConfig;
    if (organizationId) body.organizationId = organizationId;

    const { data, error } = await client.sso.register(body);
    if (error) throw error;
    return data;
  };

  const deleteProvider = async (providerId) => {
    const { data, error } = await client.sso.deleteProvider({ providerId });
    if (error) throw error;
    return data;
  };

  return {
    listProviders,
    registerProvider,
    deleteProvider,
  };
}
